import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

function AddPurchase() {
  const navigate = useNavigate();

  const generateSaleNo = () => {
    return Math.floor(1000000 + Math.random() * 9000000);
  };

  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  const [ldata, setLdata] = useState(null);
  const [image, setImage] = useState('');
  const [savedSaleData, setSavedSaleData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const [formData, setFormData] = useState({
    medicines: [],
    store_sale_id: "",
    store_purchase_no: generateSaleNo(),
    store_purchase_date: getTodayDate(),
    patient_name: "",
    patient_age: "",
    patient_gender: "",
    patient_address: "",
    patient_mobile: "",
    doctor_id: "",
    store_department: "",
    remarks: "",
  });

  const [doctorOptions, setDoctorOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);

  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const [showBatchModal, setShowBatchModal] = useState(false);
  const [batchItems, setBatchItems] = useState([]);

  // ================= LOAD EDIT DATA =================
  const loadEditData = async (saleId) => {
    try {
      const fd = new FormData();
      fd.append('sale_id', saleId);

      const response = await axios.post(
        AppConst.BASE_URL + AppConst.getSaleDetailsUrl,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.data.status) {
        const sale = response.data.sale;
        const items = response.data.items || [];

        // Format items for the table
        const formattedItems = items.map(item => ({
          store_purchase_item_id: item.store_purchase_item_id,
          store_purchase_item_name: item.store_purchase_item_name,
          store_purchase_item_unit: item.store_purchase_item_unit,
          store_batch_no: item.store_batch_no,
          price: parseFloat(item.price),
          qty: parseInt(item.qty),
          stock: 999 // We'll need to fetch actual stock, or you can add this to your backend
        }));

        // Set form data
        setFormData({
          medicines: formattedItems,
          store_sale_id: sale.store_sale_id,
          store_purchase_no: sale.store_purchase_no,
          store_purchase_date: sale.store_purchase_date,
          patient_name: sale.patient_name || "",
          patient_age: sale.patient_age || "",
          patient_gender: sale.patient_gender || "",
          patient_address: sale.patient_address || "",
          patient_mobile: sale.patient_mobile || "",
          doctor_id: sale.doctor_id || "",
          store_department: sale.store_department || "",
          remarks: sale.remarks || "",
        });

        // Set selected doctor
        if (sale.doctor_id) {
          // Wait for doctors to load, then set selected
          const checkDoctors = setInterval(() => {
            if (doctorOptions.length > 0) {
              const doctor = doctorOptions.find(d => d.value == sale.doctor_id);
              if (doctor) {
                setSelectedDoctor(doctor);
              }
              clearInterval(checkDoctors);
            }
          }, 100);
        }

        // Set selected department
        if (sale.store_department) {
          const checkDepartments = setInterval(() => {
            if (departmentOptions.length > 0) {
              const dept = departmentOptions.find(d => d.value === sale.store_department);
              if (dept) {
                setSelectedDepartment(dept);
              }
              clearInterval(checkDepartments);
            }
          }, 100);
        }

        setIsEditMode(true);
        toast.success("Sale data loaded for editing");
      }
    } catch (error) {
      console.error("Error loading edit data:", error);
      toast.error("Error loading sale data");
    }
  };

  // ================= FETCH CONFIG FOR HEADER IMAGE =================
  const fetchConfigData = async () => {
    try {
      const res = await axios.post(
        `${AppConst.BASE_URL}${AppConst.getconfig}?config_type=lab`
      );

      if (res.data.status) {
        const data = res.data;
        setImage(data.header_logo);
      }
    } catch (err) {
      console.error("Error fetching config:", err);
    }
  };

  // ================= IMAGE TO BASE64 =================
  const imageUrlToBase64 = async (url) => {
    if (!url) {
      console.error("Image URL is empty or invalid.");
      return null;
    }

    try {
      const response = await fetch(url);
      if (!response.ok) {
        console.error(`Failed to fetch image. Status: ${response.status}`);
        return null;
      }

      const blob = await response.blob();

      if (!blob.type.startsWith('image/')) {
        console.error(`The provided URL did not point to an image. Type: ${blob.type}`);
        return null;
      }

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error fetching or converting image:", error);
      return null;
    }
  };

  // ================= NUMBER TO WORDS =================
  const numberToWords = (num) => {
    if (num === null || num === undefined || isNaN(num)) return '';

    num = Math.round(Number(num));

    const a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ',
      'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ',
      'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];

    const b = ['', '', 'twenty ', 'thirty ', 'forty ', 'fifty ',
      'sixty ', 'seventy ', 'eighty ', 'ninety '];

    if (num === 0) return 'Zero Only';

    if (num.toString().length > 9) return 'Overflow';

    const n = ('000000000' + num)
      .slice(-9)
      .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);

    if (!n) return '';

    let str = '';

    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + a[n[1][1]]) + 'Crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + a[n[2][1]]) + 'Lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + a[n[3][1]]) + 'Thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + a[n[4][1]]) + 'Hundred ' : '';
    str += (n[5] != 0)
      ? ((str !== '') ? 'And ' : '') + (a[Number(n[5])] || b[n[5][0]] + a[n[5][1]])
      : '';

    return str.trim()
      .replace(/\s+/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase()) + ' Only';
  };

  // ================= FORMAT BILL DATE =================
  const formatBillDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;

    const day = String(d.getDate()).padStart(2, '0');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[d.getMonth()];
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };

  // ================= FORMAT BILL NO =================
  const formatBillNo = (billId) => {
    if (!billId) return '-';
    return String(billId).padStart(3, '0');
  };

  // ================= GENERATE PDF =================
  const generateSalePDF = async (saleData) => {
    const doc = new jsPDF("p", "pt", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 30;
    let y = 40;
  
    // Function to add header on each page
    const addHeader = async () => {
      const headerImageBase64 = await imageUrlToBase64(image);
      const headerImageHeight = 80;
  
      if (headerImageBase64) {
        doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, headerImageHeight);
      }
  
      return headerImageHeight + 20;
    };
  
    // Function to add footer with page numbers
    const addFooter = (currentPage, totalPages) => {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.text(
        `Page ${currentPage} of ${totalPages}`,
        pageWidth / 2,
        pageHeight - 20,
        { align: "center" }
      );
      doc.text(
        `Generated on ${new Date().toLocaleString()}`,
        pageWidth / 2,
        pageHeight - 10,
        { align: "center" }
      );
    };
  
    // Add header to first page
    y = await addHeader();
  
    // Title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("STORE SALE", pageWidth / 2, y, { align: "center" });
    y += 15;
  
    // Info Box
    const infoBoxHeight = 120;
    doc.rect(margin, y, pageWidth - 2 * margin, infoBoxHeight);
  
    let leftX = margin + 10;
    let rightX = pageWidth / 2 + 40;
    let lineY = y + 15;
  
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("Details:", leftX, lineY);
  
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
  
    doc.text(`Name: ${saleData.patient_name || 'N/A'}`, leftX, (lineY += 15));
    doc.text(`Age: ${saleData.patient_age || 'N/A'} years`, leftX, (lineY += 15));
    doc.text(`Gender: ${saleData.patient_gender || 'N/A'}`, leftX, (lineY += 15));
    doc.text(`Mobile: ${saleData.patient_mobile || 'N/A'}`, leftX, (lineY += 15));
    
    // Wrap address text if too long
    const addressText = `Address: ${saleData.patient_address || 'N/A'}`;
    const wrappedAddress = doc.splitTextToSize(addressText, (pageWidth / 2) - 60);
    doc.text(wrappedAddress, leftX, (lineY += 15));
  
    lineY = y + 15;
  
    doc.text(`Sale No: ${saleData.store_purchase_no || 'N/A'}`, rightX, lineY);
    doc.text(`Date: ${formatBillDate(saleData.store_purchase_date)}`, rightX, (lineY += 15));
    doc.text(`Doctor: ${saleData.doctor_name || 'N/A'}`, rightX, (lineY += 15));
    doc.text(`Dept: ${saleData.store_department || 'N/A'}`, rightX, (lineY += 15));
  
    y += infoBoxHeight + 15;
  
    // Remarks Section
    if (saleData.remarks && saleData.remarks.trim()) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text("Remarks:", margin, y);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      
      const remarksLines = doc.splitTextToSize(saleData.remarks, pageWidth - 2 * margin);
      doc.text(remarksLines, margin, y + 15);
      
      y += (remarksLines.length * 12) + 20;
    }
  
    // Items Table with auto-pagination
    const tableHeaders = [["#", "Item Name", "Batch", "Unit", "Qty", "Price", "Total"]];
  
    const tableBody = (saleData.items || []).map((item, index) => {
      const qty = parseInt(item.qty || 0);
      const price = parseFloat(item.price || 0);
      const total = price * qty;
  
      return [
        index + 1,
        item.store_purchase_item_name || '',
        item.store_batch_no || '',
        item.store_purchase_item_unit || '',
        qty,
        `${price.toFixed(2)}`,
        `${total.toFixed(2)}`,
      ];
    });
  
    autoTable(doc, {
      startY: y,
      head: tableHeaders,
      body: tableBody,
      theme: "grid",
      styles: { 
        fontSize: 9, 
        cellPadding: 4,
        lineColor: [200, 200, 200],
        lineWidth: 0.5
      },
      headStyles: { 
        fillColor: [220, 220, 220], 
        textColor: 0, 
        fontStyle: "bold",
        fontSize: 9,
        halign: 'center'
      },
      columnStyles: {
        0: { cellWidth: 30, halign: 'center' },
        1: { cellWidth: 'auto' },
        2: { cellWidth: 70 },
        3: { cellWidth: 60 },
        4: { cellWidth: 40, halign: 'right' },
        5: { cellWidth: 60, halign: 'right' },
        6: { cellWidth: 70, halign: 'right' },
      },
      margin: { left: margin, right: margin, bottom: 60 },
      didDrawPage: function(data) {
        if (data.pageNumber > 1) {
          doc.setFont("helvetica", "bold");
          doc.setFontSize(14);
          doc.text("STORE SALE (Continued)", pageWidth / 2, 30, { align: "center" });
        }
      }
    });
  
    y = doc.lastAutoTable.finalY + 15;
  
    if (y > pageHeight - 120) {
      doc.addPage();
      y = 60;
    }
  
    // Grand Total
    const grandTotal = parseFloat(saleData.total_amount || 0);
  
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text(`Grand Total`, pageWidth - margin - 150, y);
    doc.text(`Rs. ${grandTotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
  
    y += 20;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    
    const amountInWords = `Amount in Words: ${numberToWords(grandTotal)}`;
    const wrappedAmount = doc.splitTextToSize(amountInWords, pageWidth - 2 * margin);
    doc.text(wrappedAmount, margin, y);
    
    y += (wrappedAmount.length * 12) + 30;
  
    if (y > pageHeight - 80) {
      doc.addPage();
      y = 60;
    }
  
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    
    const leftSignatureX = margin + 80;
    const rightSignatureX = pageWidth - margin - 80;
    const signatureLineY = y;
    const signatureTextY = y + 15;
    
    doc.line(margin, signatureLineY, leftSignatureX * 2 - margin, signatureLineY);
    doc.text("Customer Signature", leftSignatureX, signatureTextY, { align: "center" });
  
    doc.line(pageWidth / 2 + 40, signatureLineY, pageWidth - margin, signatureLineY);
    doc.text("Authorized Signature", rightSignatureX, signatureTextY, { align: "center" });
  
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      addFooter(i, totalPages);
    }
  
    window.open(doc.output("bloburl"), "_blank");
  };

  // ================= PRINT INVOICE =================
  const handlePrintInvoice = async () => {
    if (!savedSaleData) {
      toast.error("Please save the sale first!");
      return;
    }

    await generateSalePDF(savedSaleData);
  };

  // ================= FETCH DOCTORS =================
  const getDoctors = async () => {
    try {
      const fd = new FormData();
      fd.append("type", "doctor");
      fd.append("user_cre_by", 1);

      const res = await axios.post(
        AppConst.BASE_URL + AppConst.getUserListUrl,
        fd
      );

      if (res.data.status) {
        const options = res.data.records.map(d => ({
          value: d.doctor_id,
          label: d.fname
        }));
        setDoctorOptions(options);
      }
    } catch (err) {
      console.error("Error fetching doctors:", err);
    }
  };

  // ================= FETCH DEPARTMENTS =================
  const getDepartments = async () => {
    try {
      const res = await axios.get(
        AppConst.BASE_URL + AppConst.GetAllStoreDepartments
      );

      if (res.data.status) {
        const options = res.data.list.map(d => ({
          value: d.store_settings_department,
          label: d.store_settings_department
        }));
        setDepartmentOptions(options);
      }
    } catch (err) {
      console.error("Error fetching departments:", err);
    }
  };

  // ================= ASYNC LOAD ITEMS =================
  const loadItemOptions = (inputValue, callback) => {
    const fd = new FormData();
    fd.append("search_key", inputValue || "");

    axios.post(AppConst.BASE_URL + AppConst.searchStoreItemsUrl, fd)
      .then(res => {
        console.log("API Response:", res.data);

        if (res.data.status && res.data.records && res.data.records.length > 0) {
          const groupedByName = {};
          res.data.records.forEach(item => {
            const name = item.store_purchase_item_name;
            if (!groupedByName[name]) {
              groupedByName[name] = [];
            }
            groupedByName[name].push(item);
          });

          const options = Object.keys(groupedByName).map(name => {
            const items = groupedByName[name];
            const firstItem = items[0];
            
            const batchNo = firstItem.store_purchase_item_batch_no || 
                           firstItem.store_batch_no || 
                           firstItem.batch_no || 
                           "N/A";
            
            return {
              value: name,
              label: items.length > 1 
                ? `${name} (${items.length} batches)` 
                : `${name} | Stock: ${firstItem.item_stock || 0}`,
              items: items,
              isSingleBatch: items.length === 1
            };
          });

          callback(options);
        } else {
          callback([]);
        }
      })
      .catch(err => {
        console.error("Search error:", err);
        toast.error("Error searching items");
        callback([]);
      });
  };

  // ================= HANDLE ITEM SELECT =================
  const handleItemSelect = (selected) => {
    if (!selected) return;

    console.log("Selected:", selected);

    if (selected.isSingleBatch) {
      addItemToTable(selected.items[0]);
    } else {
      setBatchItems(selected.items);
      setShowBatchModal(true);
    }

    setSelectedItem(null);
  };

  // ================= SELECT FROM MODAL =================
  const handleBatchSelect = (item) => {
    addItemToTable(item);
    setShowBatchModal(false);
    setBatchItems([]);
  };

  // ================= ADD ITEM TO TABLE =================
  const addItemToTable = (item) => {
    console.log("Adding item:", item);

    const batchNo = item.store_purchase_item_batch_no || 
                   item.store_batch_no || 
                   item.batch_no || 
                   "N/A";

    const exists = formData.medicines.find(
      (m) =>
        m.store_purchase_item_id === item.store_purchase_item_id &&
        m.store_batch_no === batchNo
    );

    if (exists) {
      toast.error("This batch already added!");
      return;
    }

    setFormData(prev => ({
      ...prev,
      medicines: [
        ...prev.medicines,
        {
          store_purchase_item_id: item.store_purchase_item_id,
          store_purchase_item_name: item.store_purchase_item_name || "N/A",
          store_purchase_item_unit: item.store_purchase_item_unit || "N/A",
          store_batch_no: batchNo,
          price: item.store_purchase_item_MRP || 0,
          qty: 1,
          stock: item.item_stock || 0
        }
      ]
    }));

    toast.success("Item added!");
  };

  const handleQtyChange = (index, value) => {
    const updated = [...formData.medicines];

    if (parseInt(value) > parseInt(updated[index].stock)) {
      toast.error("Stock not available!");
      return;
    }

    updated[index].qty = value;

    setFormData(prev => ({
      ...prev,
      medicines: updated
    }));
  };

  const removeItem = (index) => {
    const updated = formData.medicines.filter((_, i) => i !== index);
    setFormData(prev => ({ ...prev, medicines: updated }));
  };

  // ================= CANCEL =================
  const handleCancel = () => {
    sessionStorage.removeItem("opd_dt"); // Clear edit data
    navigate("/store_sales");
  };

  // ================= SAVE =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.medicines.length === 0) {
      toast.error("Add at least one item!");
      return;
    }

    try {
      const fd = new FormData();

      // Add sale_id if editing
      if (formData.store_sale_id) {
        fd.append("store_sale_id", formData.store_sale_id);
      }
      
      fd.append("store_purchase_no", formData.store_purchase_no);
      fd.append("store_purchase_date", formData.store_purchase_date);
      fd.append("patient_name", formData.patient_name);
      fd.append("patient_age", formData.patient_age);
      fd.append("patient_gender", formData.patient_gender);
      fd.append("patient_address", formData.patient_address);
      fd.append("patient_mobile", formData.patient_mobile);
      fd.append("doctor_id", formData.doctor_id);
      fd.append("store_department", formData.store_department);
      fd.append("remarks", formData.remarks);
      fd.append("items", JSON.stringify(formData.medicines));
      fd.append("user_id", ldata?.user_id);

      const res = await axios.post(
        AppConst.BASE_URL + AppConst.saveStoreSaleUrl,
        fd
      );

      if (res.data.status) {
        toast.success(isEditMode ? "Sale Updated Successfully!" : "Sale Saved Successfully!");
        
        // Get doctor name
        const doctor = doctorOptions.find(d => d.value == formData.doctor_id);
        
        const pdfData = {
          ...formData,
          store_sale_id: res.data.sale_id,
          total_amount: res.data.total_amount,
          doctor_name: doctor ? doctor.label : '',
          items: formData.medicines
        };
        
        setSavedSaleData(pdfData);
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.error("Save error:", err);
      toast.error("Error saving sale");
    }
  };

  // ================= LOAD EDIT DATA ON MOUNT =================
  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
    const editData = sessionStorage.getItem("opd_dt");
    
    if (storedData) {
      setLdata(JSON.parse(storedData));
      getDoctors();
      getDepartments();
      fetchConfigData();
    }

    // Check if edit mode
    if (editData) {
      const saleToEdit = JSON.parse(editData);
      console.log("Edit data found:", saleToEdit);
      
      // Load the full sale details
      if (saleToEdit.store_sale_id) {
        loadEditData(saleToEdit.store_sale_id);
      }
    }
  }, []);

  // ================= SET SELECTED OPTIONS AFTER LOADING =================
  useEffect(() => {
    if (formData.doctor_id && doctorOptions.length > 0 && !selectedDoctor) {
      const doctor = doctorOptions.find(d => d.value == formData.doctor_id);
      if (doctor) {
        setSelectedDoctor(doctor);
      }
    }
  }, [formData.doctor_id, doctorOptions]);

  useEffect(() => {
    if (formData.store_department && departmentOptions.length > 0 && !selectedDepartment) {
      const dept = departmentOptions.find(d => d.value === formData.store_department);
      if (dept) {
        setSelectedDepartment(dept);
      }
    }
  }, [formData.store_department, departmentOptions]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <h5>{isEditMode ? 'Edit Sale' : 'New Sale'}</h5>

            <form onSubmit={handleSubmit}>
              <div className="row">

                <div className="col-md-3">
                  <label>Name <span className="text-danger">*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.patient_name}
                    onChange={(e)=>setFormData({...formData,patient_name:e.target.value})}
                    required
                  />
                </div>

                <div className="col-md-3">
                  <label>Age <span className="text-danger">*</span></label>
                  <input
                    type="number"
                    className="form-control"
                    value={formData.patient_age}
                    onChange={(e)=>setFormData({...formData,patient_age:e.target.value})}
                    required
                  />
                </div>

                <div className="col-md-3">
                  <label>Mobile No</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.patient_mobile}
                    onChange={(e)=>setFormData({...formData,patient_mobile:e.target.value})}
                  />
                </div>

                <div className="col-md-3">
                  <label>Gender</label>
                  <select
                    className="form-control"
                    value={formData.patient_gender}
                    onChange={(e)=>setFormData({...formData,patient_gender:e.target.value})}
                  >
                    <option value="">Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className="col-md-12 mt-3">
                  <label>Address</label>
                  <textarea
                    className="form-control"
                    rows="2"
                    value={formData.patient_address}
                    onChange={(e)=>setFormData({...formData,patient_address:e.target.value})}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label>Doctor</label>
                  <Select
                    options={doctorOptions}
                    value={selectedDoctor}
                    onChange={(s)=>{
                      setSelectedDoctor(s);
                      setFormData({...formData,doctor_id:s?.value || ""});
                    }}
                    isClearable
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label>Department</label>
                  <Select
                    options={departmentOptions}
                    value={selectedDepartment}
                    onChange={(s)=>{
                      setSelectedDepartment(s);
                      setFormData({...formData,store_department:s?.value || ""});
                    }}
                    isClearable
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label>Remarks </label>
                  <textarea
                    className="form-control"
                    rows="2"
                    value={formData.remarks}
                    onChange={(e)=>setFormData({...formData,remarks:e.target.value})}
                    placeholder="Additional notes or remarks..."
                    
                  />
                </div>

                {/* ITEM SEARCH - ASYNC SELECT */}
                <div className="col-12 mt-4">
                  <label>Search Item</label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-barcode-line"></i>
                    </span>
                    <div style={{ flex: 1 }}>
                      <AsyncSelect
                        cacheOptions
                        defaultOptions
                        loadOptions={loadItemOptions}
                        value={selectedItem}
                        onChange={handleItemSelect}
                        placeholder="Click to view items or type to search..."
                        isClearable
                        noOptionsMessage={() => "No items found"}
                      />
                    </div>
                  </div>
                </div>

                {/* ITEM TABLE */}
                <div className="col-12 mt-4">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Item Name</th>
                        <th>Batch No</th>
                        <th>Unit</th>
                        <th>Qty</th>
                        <th>Price</th>
                        <th>Total</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {formData.medicines.length === 0 ? (
                        <tr>
                          <td colSpan="8" className="text-center">No items added</td>
                        </tr>
                      ) : (
                        formData.medicines.map((item, index)=>(
                          <tr key={index}>
                            <td>{index+1}</td>
                            <td>{item.store_purchase_item_name}</td>
                            <td>{item.store_batch_no}</td>
                            <td>{item.store_purchase_item_unit}</td>
                            <td style={{width: '100px'}}>
                              <input
                                type="number"
                                value={item.qty}
                                className="form-control"
                                min="1"
                                onChange={(e)=>handleQtyChange(index,e.target.value)}
                              />
                            </td>
                            <td>₹{parseFloat(item.price).toFixed(2)}</td>
                            <td>₹{(parseFloat(item.price) * parseInt(item.qty)).toFixed(2)}</td>
                            <td>
                              <button 
                                type="button"
                                className="btn btn-sm btn-danger"
                                onClick={()=>removeItem(index)}
                              >
                                <i className="ri-delete-bin-line"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                    {formData.medicines.length > 0 && (
                      <tfoot>
                        <tr>
                          <th colSpan="6" className="text-end">Grand Total:</th>
                          <th>₹{formData.medicines.reduce((sum, item) => 
                            sum + (parseFloat(item.price) * parseInt(item.qty)), 0
                          ).toFixed(2)}</th>
                          <th></th>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>

                <div className="col-12 text-end mt-3">
                  <button 
                    type="button" 
                    className="btn btn-secondary me-2"
                    onClick={handleCancel}
                  >
                    <i className="ri-close-line me-1"></i>
                    Cancel
                  </button>
                  
                  {savedSaleData && (
                    <button 
                      type="button" 
                      className="btn btn-info me-2"
                      onClick={handlePrintInvoice}
                    >
                      <i className="ri-printer-fill me-1"></i>
                      Print Invoice
                    </button>
                  )}
                  
                  <button type="submit" className="btn btn-success">
                    <i className="ri-save-line me-1"></i>
                    {isEditMode ? 'Update Sale' : 'Save Sale'}
                  </button>
                </div>

              </div>
            </form>

          </div>
        </div>
      </div>

      {/* BATCH SELECTION MODAL */}
      {showBatchModal && (
        <div 
          className="modal fade show" 
          style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}
          onClick={() => setShowBatchModal(false)}
        >
          <div 
            className="modal-dialog modal-lg modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Select Batch</h5>
                <button 
                  type="button" 
                  className="btn-close"
                  onClick={() => setShowBatchModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <table className="table table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>Sl No</th>
                      <th>Medicine Name</th>
                      <th>Batch No</th>
                      <th>Stock</th>
                      <th>Price</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {batchItems.map((item, index) => {
                      const batchNo = item.store_purchase_item_batch_no || 
                                     item.store_batch_no || 
                                     item.batch_no || 
                                     "N/A";
                      return (
                        <tr key={index} style={{cursor: 'pointer'}} onClick={() => handleBatchSelect(item)}>
                          <td>{index + 1}</td>
                          <td>{item.store_purchase_item_name || "N/A"}</td>
                          <td>{batchNo}</td>
                          <td>{item.item_stock || 0}</td>
                          <td>₹{parseFloat(item.store_purchase_item_MRP || 0).toFixed(2)}</td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-sm btn-primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleBatchSelect(item);
                              }}
                            >
                              Select
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddPurchase;